import React, { Component } from 'react';
import i18n from '../i18n';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import DoorControlsActions from '../redux/DoorControlsRedux';
import SchedulesActions from '../redux/SchedulesRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Modal from '../components/common/Modal';
import DoorControlDetails from '../components/doorControlsElements/DoorControlDetails';
import AddDoorsModal from '../components/doorControlsElements/AddDoorsModal';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class DoorControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      // doorControls page params
      doorControlsItemsPerPage: 10,
      doorControlsPageNumber: 0,
      doorControlsSearchValue: null,
      doorControlsSortDirection: 'ASC',
      // doorControls details
      hideDetails: true,
      isNewDoorControl: false,
      doorControlId: null,
      name: '',
      description: '',
      scheduleNameId: '',
      // door controls Form Errors:
      isUntouched: true,
      // add doors modal
      checkedDoors: [],
      isDoorsModalOpen: false,
      doorsModalItemsPerPage: 10,
      doorsModalPageNumber: 0,
      doorsModalSearchValue: null,
      doorsModalSortBy: 'controllerUid',
      doorsModalSortDirection: 'ASC',
      // doors table
      doorsItemsPerPage: 10,
      doorsPageNumber: 0,
      doorsSearchValue: null,
      doorsSortBy: 'controllerUid',
      doorsSortDirection: 'ASC',
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetDoorControlsRequest();
      this.sendGetSchedules();
    }
  }

  componentWillUnmount() {
    this.props.resetDoorControls();
    this.props.resetControllers();
    this.props.resetAvailableControllers();
    this.props.resetSchedules();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetDoorControls();
      this.props.resetControllers();
      this.props.resetAvailableControllers();
      this.props.resetSchedules();
      this.resetDoorControlFormFields();
      if (this.props.customerId) {
        this.sendGetDoorControlsRequest();
        this.sendGetSchedules();
      }
    }
    if (prevProps.doorControlsIsLoading && !this.props.doorControlsIsLoading) {
      if (this.props.doorControlsSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.doorControlsSuccessMessage,
        });
      }
      if (this.props.doorControlsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.doorControlsErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ doorControlId: this.props.createdId, isUntouched: true, isNewDoorControl: false });
      }
    }
  }

  // doorControls list table methods

  sendGetDoorControlsRequest() {
    const pageParams = {
      items: this.state.doorControlsItemsPerPage,
      page: this.state.doorControlsPageNumber,
      value: this.state.doorControlsSearchValue,
      sort: this.state.doorControlsSortDirection,
    };
    this.props.getDoorControls(pageParams, this.props.customerId);
  }

  sendGetSchedules() {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sort: 'ASC',
    };
    this.props.getSchedules(this.props.customerId, pageParams);
  }

  changedoorControlsItemsPerPage = (doorControlsItemsPerPage) => {
    this.setState({ doorControlsItemsPerPage, doorControlsPageNumber: 0 }, () => this.sendGetDoorControlsRequest());
  };

  changedoorControlsPage = (doorControlsPageNumber) => {
    this.setState({ doorControlsPageNumber }, () => this.sendGetDoorControlsRequest());
  };

  handleSearchDoorControl = (doorControlsSearchValue) => {
    this.setState({ doorControlsSearchValue, doorControlsPageNumber: 0 }, () => this.sendGetDoorControlsRequest());
    this.resetDoorControlFormFields();
  };

  handleSortDoorControl = (doorControlsSortBy, doorControlsSortDirection) => {
    this.setState({ doorControlsSortDirection, doorControlsPageNumber: 0 }, () => this.sendGetDoorControlsRequest());
    this.resetDoorControlFormFields();
  };

  handleSearchDoorControlKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchDoorControl(value);
    }
  };

  selectDoorControl = ({ doorControlId, name, description, scheduleNameId }) => {
    this.resetDoorControlFormFields();
    this.setState(
      {
        hideDetails: false,
        isNewDoorControl: false,
        doorControlId,
        name,
        description,
        scheduleNameId,
      },
      () => this.sendGetControllersRequest()
    );
  };

  // doorControl details form methods

  resetDoorControlFormFields = () => {
    this.setState({
      doorControlId: null,
      name: '',
      description: '',
      scheduleNameId: '',
      checkedDoors: [],
      isUntouched: true,
    });
    this.props.resetControllers();
  };

  handleAddDoorControl = () => {
    this.resetDoorControlFormFields();
    this.setState({ hideDetails: false, doorControlsSearchValue: null, isNewDoorControl: true });
  };

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleDoorControlDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.usersSearchValue) {
        return this.handleSaveDoorControl();
      }
    }
  };

  handleSaveDoorControl = () => {
    const { doorControlId, name, description, scheduleNameId, checkedDoors } = this.state;
    const doorControlInfo = {
      name,
      description,
      exceptionDateId: null,
      scheduleNameId,
      customerId: this.props.customerId,
    };
    const editDoorControlInfos = { ...doorControlInfo, doorControlId };
    const doorControlParams = {
      items: this.state.doorControlsItemsPerPage,
      page: this.state.doorControlsPageNumber,
      value: this.state.doorControlsSearchValue,
      sort: this.state.doorControlsSortDirection,
    };
    const controllersParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
      sortBy: this.state.doorsSortBy,
      sortDirection: this.state.doorsSortDirection,
    };
    this.state.isNewDoorControl
      ? this.props.createDoorControl(
          doorControlInfo,
          checkedDoors,
          doorControlParams,
          controllersParams,
          this.props.customerId
        )
      : this.props.editDoorControl(editDoorControlInfos, doorControlParams, this.props.customerId);
  };

  openDeleteDoorControlAlert = () => {
    const doorControlName = this.state.name;
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteDoorControlTitle'),
      alertContentText: i18n.t('doorControlManager_confirmDelete', { doorControlName }),
      alertConfirmAction: this.deleteDoorControl,
    });
  };

  deleteDoorControl = () => {
    const pageParams = {
      items: this.state.doorControlsItemsPerPage,
      page: this.state.doorControlsPageNumber,
      value: this.state.doorControlsSearchValue,
      sort: this.state.doorControlsSortDirection,
    };
    this.props.deleteDoorControl(this.state.doorControlId, pageParams, this.props.customerId);
    this.resetDoorControlFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  // controllers methods

  sendGetControllersRequest() {
    const pageParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
      sortBy: this.state.doorsSortBy,
      sortDirection: this.state.doorsSortDirection,
    };
    this.props.getDoorControlControllers(this.state.doorControlId, pageParams);
  }

  openDeleteControllerAlert = (controller) => {
    // this.selectController(controller);
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteDoorTitle'),
      alertContentText: i18n.t('siteManager_confirmDeleteController', {
        name: controller.name,
      }),
      alertConfirmAction: () => this.deleteController(controller),
    });
  };

  deleteController = (controller) => {
    const controllers = [controller];
    const pageParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
      sortBy: this.state.doorsSortBy,
      sortDirection: this.state.doorsSortDirection,
    };
    this.props.deleteDoorControlControllers(this.state.doorControlId, controllers, pageParams);
    this.setState({ isAlertDialogOpen: false });
  };

  // doors table params options
  changeDoorsItemsPerPage = (doorsItemsPerPage) => {
    this.setState({ doorsItemsPerPage, doorsPageNumber: 0 }, () => this.sendGetControllersRequest());
  };

  changeDoorsPage = (doorsPageNumber) => {
    this.setState({ doorsPageNumber }, () => this.sendGetControllersRequest());
  };

  handleSearchDoor = (doorsSearchValue) => {
    this.setState({ doorsSearchValue, doorsPageNumber: 0 }, () => this.sendGetControllersRequest());
  };

  handleSearchDoorKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchDoor(value);
    }
  };

  handleSortDoor = (doorsSortBy, doorsSortDirection) => {
    this.setState({ doorsSortBy, doorsSortDirection, doorsPageNumber: 0 }, () => this.sendGetControllersRequest());
  };

  // Doors modal methods

  handleAddDoor = () => {
    this.sendGetAvailableDoorsRequest();
    this.setState({ isDoorsModalOpen: true });
  };

  sendGetAvailableDoorsRequest() {
    const pageParams = {
      items: this.state.doorsModalItemsPerPage,
      page: this.state.doorsModalPageNumber,
      value: this.state.doorsModalSearchValue,
      sortBy: this.state.doorsModalSortBy,
      sortDirection: this.state.doorsModalSortDirection,
    };
    this.props.getAvailableControllers(pageParams, this.props.customerId);
  }

  changeDoorsModalItemsPerPage = (doorsItemsPerPage) => {
    this.setState({ doorsItemsPerPage, doorsPageNumber: 0 }, () => this.sendGetAvailableDoorsRequest());
  };

  changeDoorsModalPage = (doorsModalPageNumber) => {
    this.setState({ doorsModalPageNumber }, () => this.sendGetAvailableDoorsRequest());
  };

  handleSearchDoorModal = (doorsModalSearchValue) => {
    this.setState({ doorsModalSearchValue, doorsModalPageNumber: 0 }, () => this.sendGetAvailableDoorsRequest());
  };

  handleSearchDoorModalKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchDoorModal(value);
    }
  };

  handleSortDoorModal = (doorsModalSortBy, doorsModalSortDirection) => {
    this.setState({ doorsModalSortBy, doorsModalSortDirection, doorsModalPageNumber: 0 }, () =>
      this.sendGetAvailableDoorsRequest()
    );
  };

  selectDoor = (door) => {
    const previousDoors = this.state.checkedDoors;
    //check if the door was present in checkedDoors
    const selectedIndex = previousDoors.findIndex((item) => item.controllerId === door.controllerId);
    let newCheckedDoors = [];

    if (selectedIndex === -1) {
      // if not found, add it
      newCheckedDoors = newCheckedDoors.concat(previousDoors, door);
    } else if (selectedIndex === 0) {
      // if first item, remove it
      newCheckedDoors = newCheckedDoors.concat(previousDoors.slice(1));
    } else if (selectedIndex === previousDoors.length - 1) {
      // if last item, remove it
      newCheckedDoors = newCheckedDoors.concat(previousDoors.slice(0, -1));
    } else if (selectedIndex > 0) {
      // if between first and last, remove it
      newCheckedDoors = newCheckedDoors.concat(
        previousDoors.slice(0, selectedIndex),
        previousDoors.slice(selectedIndex + 1)
      );
    }
    this.setState({ checkedDoors: newCheckedDoors });
  };

  closeDoorsModalWithoutSave = () => {
    this.setState({ checkedDoors: [], isDoorsModalOpen: false });
  };

  saveDoors = () => {
    const controllers = this.state.checkedDoors.map(({ controllerId }) => ({ controllerId }));
    const pageParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
      sortBy: this.state.doorsSortBy,
      sortDirection: this.state.doorsSortDirection,
    };
    !this.state.isNewDoorControl &&
      this.props.addDoorControlControllers(this.state.doorControlId, controllers, pageParams);
    this.setState({ isDoorsModalOpen: false, ...(!this.state.isNewDoorControl && { checkedDoors: [] }) });
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const doorControlsData = cloneDeep(this.props.doorControls);
    const controllersData = this.state.isNewDoorControl ? this.state.checkedDoors : cloneDeep(this.props.controllers);
    const allControllersData = cloneDeep(this.props.availableControllers);

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t('Global_delete')}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        {/* add doors modal */}
        <Modal
          open={this.state.isDoorsModalOpen}
          handleClose={this.closeDoorsModalWithoutSave}
          Content={AddDoorsModal}
          onClickSave={this.saveDoors}
          // search door controls table props
          checkboxColumn="start"
          data={allControllersData}
          noDataText={t('sites.noDoor')}
          handleClick={(door) => this.selectDoor(door)}
          columns={[
            { title: t('doorScheduleManager_addControllersModal_col1'), field: 'controllerUid' },
            { title: t('doorScheduleManager_addControllersModal_col2'), field: 'name' },
          ]}
          handleSearch={this.handleSearchDoorModal}
          sortBy={this.state.doorsModalSortBy}
          sortDirection={this.state.doorsModalSortDirection}
          handleSort={this.handleSortDoorModal}
          activeRowField={'controllerId'}
          checkedArray={this.state.checkedDoors}
          searchPlaceholder={t('doorControlManager_addControllersModal_searchControllers')}
          itemsPerPage={this.state.doorsModalItemsPerPage}
          changeItemsPerPage={this.changeDoorsModalItemsPerPage}
          totalElements={this.props.availableControllersTotalElements}
          page={this.state.doorsModalPageNumber}
          changePage={this.changeDoorsModalPage}
          onKeyPress={this.handleSearchDoorModalKeyPress}
          // rows per page select props
          selectData={[5, 10, 20]}
          selectLabel={t('table.showPerPage')}
          selectValue={this.state.doorsModalItemsPerPage}
          onSelect={this.changeDoorsModalItemsPerPage}
          selectWidth={90}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={doorControlsData}
                noDataText={t('doorControls.noDoorControl')}
                handleClick={(value) => this.selectDoorControl(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.doorControlId}
                activeRowField={'doorControlId'}
                handleSearch={this.handleSearchDoorControl}
                sortBy={'name'}
                sortDirection={this.state.doorControlsSortDirection}
                handleSort={this.handleSortDoorControl}
                searchPlaceholder={t('doorControlManager_alevelSearch')}
                itemsPerPage={this.state.doorControlsItemsPerPage}
                changeItemsPerPage={this.changedoorControlsItemsPerPage}
                totalElements={this.props.doorControlsTotalElements}
                page={this.state.doorControlsPageNumber}
                changePage={this.changedoorControlsPage}
                onKeyPress={this.handleSearchDoorControlKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.doorControlsItemsPerPage}
                onSelect={this.changedoorControlsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <DoorControlDetails
                copyable
                // buttons
                add1ButtonText={t('doorControlManager_addNewDoorControl')}
                add2ButtonText={t('doorControlManager_addControllersToDControl')}
                onDeleteButtonClick={this.openDeleteDoorControlAlert}
                onAdd1ButtonClick={this.handleAddDoorControl}
                onAdd2ButtonClick={this.handleAddDoor}
                // add2ButtonDisabled={this.state.isNewDoorControl}
                onSaveButtonClick={this.handleSaveDoorControl}
                isDeleteButtonDisabled={!this.state.doorControlId || this.state.isNewDoorControl}
                // details form
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                doorControlId={this.state.doorControlId}
                name={this.state.name}
                description={this.state.description}
                // schedules select
                schedulesSelectData={this.props.schedules}
                schedulesSelectLabel={t('doorControlManager_aLevelSchedule_header')}
                schedulesAccessValue={'scheduleNameId'}
                schedulesAccessLabel={'name'}
                schedulesSelectValue={this.state.scheduleNameId}
                schedulesOnSelect={(scheduleNameId) => this.setState({ scheduleNameId })}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                isNewDoorControl={this.state.isNewDoorControl}
                checkedDoors={this.state.checkedDoors}
                // controllers/doors table
                tableTitle={t('doorControlManager_controllers_header')}
                data={controllersData}
                columns={[
                  { title: t('siteManager_controllers_col1'), field: 'controllerUid' },
                  { title: t('siteManager_addControllersModal_col2'), field: 'name' },
                ]}
                handleSearch={this.handleSearchDoor}
                sortBy={this.state.doorsSortBy}
                sortDirection={this.state.doorsSortDirection}
                handleSort={this.handleSortDoor}
                noDataText={t('sites.noDoor')}
                handleClick={null}
                deleteColumn
                handleDeleteButtonClick={(door) => this.openDeleteControllerAlert(door)}
                searchPlaceholder={t('doorControlManager_addControllersModal_searchControllers')}
                itemsPerPage={this.state.doorsItemsPerPage}
                changeItemsPerPage={this.changeDoorsItemsPerPage}
                totalElements={this.props.controllersTotalElements}
                page={this.state.doorsPageNumber}
                changePage={this.changeDoorsPage}
                onKeyPress={this.handleSearchDoorKeyPress}
                searchDisabled={!this.props.doorControlId}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.doorsItemsPerPage}
                onSelect={this.changeDoorsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    //doorControls
    doorControls: state.doorControls.doorControls,
    doorControlsTotalElements: state.doorControls.totalElements,
    createdId: state.doorControls.createdId,
    doorControlsIsLoading: state.doorControls.isLoading,
    doorControlsSuccessMessage: state.doorControls.successMessage,
    doorControlsErrorMessage: state.doorControls.errorMessage,
    // controllers
    controllers: state.doorControls.controllers,
    controllersTotalElements: state.doorControls.controllersTotalElements,
    availableControllers: state.doorControls.availableControllers,
    availableControllersTotalElements: state.doorControls.availableControllersTotalElements,
    // schedules
    schedules: state.schedules.schedules,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // doorControls
  getDoorControls: (pageParams, customerId) =>
    dispatch(DoorControlsActions.getDoorControlsRequest(pageParams, customerId)),
  createDoorControl: (doorControlInfo, controllers, doorControlParams, controllersParams, customerId) =>
    dispatch(
      DoorControlsActions.createDoorControlRequest(
        doorControlInfo,
        controllers,
        doorControlParams,
        controllersParams,
        customerId
      )
    ),
  editDoorControl: (doorControlInfo, pageParams, customerId) =>
    dispatch(DoorControlsActions.editDoorControlRequest(doorControlInfo, pageParams, customerId)),
  deleteDoorControl: (doorControlId, pageParams, customerId) =>
    dispatch(DoorControlsActions.deleteDoorControlRequest(doorControlId, pageParams, customerId)),
  resetDoorControls: () => dispatch(DoorControlsActions.resetDoorControls()),
  // controllers
  resetControllers: () => dispatch(DoorControlsActions.resetControllers()),
  resetAvailableControllers: () => dispatch(DoorControlsActions.resetAvailableControllers()),
  getAvailableControllers: (pageParams, customerId) =>
    dispatch(DoorControlsActions.getAvailableControllersRequest(pageParams, customerId)),
  getDoorControlControllers: (doorControlId, pageParams) =>
    dispatch(DoorControlsActions.getDoorControlControllersRequest(doorControlId, pageParams)),
  addDoorControlControllers: (doorControlId, controllers, pageParams) =>
    dispatch(DoorControlsActions.addDoorControlControllersRequest(doorControlId, controllers, pageParams)),
  deleteDoorControlControllers: (doorControlId, controllers, pageParams) =>
    dispatch(DoorControlsActions.deleteDoorControlControllersRequest(doorControlId, controllers, pageParams)),
  // schedules
  getSchedules: (customerId, pageParams) => dispatch(SchedulesActions.getSchedulesRequest(customerId, pageParams)),
  resetSchedules: () => dispatch(SchedulesActions.resetSchedules()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(DoorControls);
